import React, { Component } from "react";
import code_app from "images/index/code-app.png";
import code_wechat from "images/index/code-wechat.png";
import Request from "../../networkReq/request";
import Http from "../../networkReq/http";
import footer1 from "../../images/footer1.png";
import cbottomerweim from "../../img/QRCode.png";
import red from "../../images/red.png";
import anBei from "../../images/anBei.png";
import jiucuo from "../../images/jiucuo.png";

require("./index.scss");

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "0",
    };
  }

  componentDidMount() {}

  handleClick = (cid) => {
    const { id } = this.state;
    if (id === cid) {
      this.setState({
        id: 0,
      });
    } else {
      this.setState({
        id: cid,
      });
    }
  };

  render() {
    const { id } = this.state;
    return (
      <div className="c_footer">
        <div className="c_bottomlink w1200  footer">
          <div className="c_bottomdibu w700 ">
            <div className="c_bottominfo" style={{ display: "inline-block" }}>
              <div className="footre_logo">眉山市退役军人就业创业网</div>
              <div className="footre003">主管单位：眉山市退役军人事务局</div>
              <div className="footre003">承办单位：眉山市退役军人服务中心</div>
              <div className="footre004" style={{ float: "left" }}>
                <a target="_blank" href="http://beian.miit.gov.cn">
                  蜀ICP备2022019739号
                </a>
              </div>
            </div>
            <div className="c_bottomerwei">
              <img src={cbottomerweim} alt="" />
              <div>眉山市退役军人事务局</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Footer;
